import * as undoActions from 'owa-mail-undo';
import composeStore from 'owa-mail-compose-store/lib/store/composeStore';
import createItemContextsForDeleteStoreUpdate from './helpers/createItemContextsForDeleteStoreUpdate';
import datapoints from './datapoints';
import deleteItemService from 'owa-mail-store/lib/services/deleteItemService';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import deleteMailListRowsHelper from './helpers/deleteMailListRowsHelper';
import { isDeletedItemsFolderFromAnyMailbox } from 'owa-mail-store';
import handleBlockActionForShadowMailbox from '../actions/helpers/handleBlockActionForShadowMailbox';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { getStore } from 'owa-mail-store/lib/store/Store';
import restoreItemService from '../services/restoreItemService';
import showNotificationOnDeleteSucceeded from './helpers/showNotificationOnDeleteSucceeded';
import strings from 'owa-strings/owa-mail-strings';
import { action, select } from 'satcheljs/lib/legacy';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { logUsage } from 'owa-analytics';
import { resetFocus } from 'owa-mail-focus-manager';
import { userMailInteractionAction } from 'owa-mail-actions';
import { MailboxType } from 'owa-client-ids';
import { isFolderUnderArchiveRoot } from 'owa-mail-store';
function isReplyingToOneOfItems(itemIds) {
    var replyItemId = composeStore.defaultViewState && composeStore.defaultViewState.itemId;
    return replyItemId && itemIds.indexOf(replyItemId.Id) >= 0;
}
/**
 * The action worker which handles deleting the given items
 * Note: This aciton is exported only for unit testing purposes
 * @param itemIds - the conversation that need to be deleted
 * @param originalTableView - the table view the conversation should be deleted from
 * @param disposalType - the disposal type
 * @param parentFolderId - the parent FolderId
 * @param actionSource - the action source
 */
export var deleteItemsWithoutConfirmDialog = action('deleteItemsWithoutConfirmDialog', datapoints.deleteItemsDatapoint)(function deleteItemsWithoutConfirmDialog(itemIds, disposalType, parentFolderId, actionSource, instrumentationContexts, requestInitOptions, allowUndoAction) {
    if (allowUndoAction === void 0) { allowUndoAction = true; }
    var itemContexts = createItemContextsForDeleteStoreUpdate(itemIds);
    // Dispatch action to update the store state
    deleteItemsStoreUpdate(itemContexts, parentFolderId);
    undoActions.clearLastUndoableAction();
    // Make service request
    var serviceItemIds = itemIds.map(function (itemIdValue) {
        return {
            Id: itemIdValue,
        };
    });
    deleteItemService(serviceItemIds, disposalType, requestInitOptions).then(function (responseItems) {
        if (disposalType === 'MoveToDeletedItems' && allowUndoAction) {
            var numberOfItemsAddedToUndoStack = addDeletedItemsToUndoStack(responseItems);
            if (numberOfItemsAddedToUndoStack > 0) {
                showNotificationOnDeleteSucceeded(numberOfItemsAddedToUndoStack);
            }
        }
    });
    userMailInteractionAction('Delete', instrumentationContexts);
});
export var deleteItems = action('deleteItems')(function deleteItems(itemIds, disposalType, actionSource, instrumentationContexts, mailboxInfo) {
    // Early return if the action is blocked for shadow mailbox
    var firstItem = getStore().items.get(itemIds[0]);
    var sourceFolderId = firstItem.ParentFolderId.Id;
    if (handleBlockActionForShadowMailbox(sourceFolderId, null)) {
        return Promise.resolve();
    }
    var requestInitOptions = mailboxInfo ? mailboxInfo.requestOptions : null;
    var isGroup = mailboxInfo && mailboxInfo.type == MailboxType.GroupMailbox;
    var isDeletedItemsFolder = isDeletedItemsFolderFromAnyMailbox(sourceFolderId);
    var shouldUserConfirmDeletion = (disposalType == 'SoftDelete' && isDeletedItemsFolder) || isGroup;
    return confirm(isGroup ? strings.confirmDeletingGroupItemTitle : '', isGroup ? strings.confirmDeletingGroupItem : strings.confirmDeletingItem, !shouldUserConfirmDeletion /*resolveImmediately*/, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        // Not applicable for groups and archive mailbox folder
        var allowUndoAction = !isGroup && !isFolderUnderArchiveRoot(sourceFolderId);
        if (response == DialogResponse.ok) {
            deleteItemsWithoutConfirmDialog(itemIds, disposalType, sourceFolderId, actionSource, instrumentationContexts, requestInitOptions, allowUndoAction);
            resetFocus();
        }
        return Promise.resolve();
    });
});
/**
 * Initiates deleting of selected items
 * @param itemRowKeys - row keys to be deleted
 * @param originalTableViewId - the table view the conversation should be deleted from
 * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
 * @param actionSource - the action source
 * @param state - some additional state required to complete the action
 */
export var deleteItemsFromTable = select({
    originalTableView: function (conversationId, originalTableViewId) {
        return listViewStore.tableViews.get(originalTableViewId);
    },
})(function deleteItemsFromTable(itemRowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource, state) {
    var confirmDialogStrings = {
        deleteNumberOfRowsTitle: strings.deleteNumberOfItems,
        deleteOneRowTitle: strings.deleteItem,
        confirmDeleteRows: strings.confirmDeletingItems,
    };
    logUsage(datapoints.deleteItemsFromTableDatapoint.datapoint.name, datapoints.deleteItemsFromTableDatapoint.datapoint.customData(itemRowKeys, originalTableViewId, actionSource));
    return deleteMailListRowsHelper(itemRowKeys, originalTableViewId, isExplicitSoftDelete, function (rowKeys, disposalType) {
        var rowIdStrings = getRowIdsFromRowKeys(rowKeys, originalTableViewId);
        deleteItemsWithoutConfirmDialog(rowIdStrings, disposalType, state.originalTableView.tableQuery.folderId, actionSource, instrumentationContexts);
    }, isReplyingToOneOfItems, confirmDialogStrings);
});
function addDeletedItemsToUndoStack(responseItems) {
    var movedItemIds = [];
    for (var _i = 0, responseItems_1 = responseItems; _i < responseItems_1.length; _i++) {
        var responseItem = responseItems_1[_i];
        var deleteItemResponse = responseItem;
        if (deleteItemResponse.ResponseClass == 'Success') {
            movedItemIds.push(deleteItemResponse.MovedItemId.Id);
        }
    }
    if (movedItemIds.length > 0) {
        undoActions.addActionToUndoStack(function () {
            return restoreItemService(movedItemIds);
        });
    }
    return movedItemIds.length;
}
//# sourceMappingURL=deleteItems.js.map